<div class="container">
    <app-password [requestOld]="this.resetToken == null" [markWrongPassword]="markWrongPassword" (passwordValidated)="changePassword($event)"></app-password>
</div>
